[
  {
    "id": "card-ataque-15",
    "name": "Filo Afilado",
    "desc": "Aumenta el ataque del héroe en 15%.",
    "rarity": 1,
    "baseCost": 50,
    "effect": { "kind": "stat", "stat": "atkPct", "add": 15 }
  },
  {
    "id": "card-ataque-30",
    "name": "Filo Templado",
    "desc": "Aumenta el ataque del héroe en 30%.",
    "rarity": 3,
    "baseCost": 140,
    "effect": { "kind": "stat", "stat": "atkPct", "add": 30 }
  },
  {
    "id": "card-ataque-100",
    "name": "Furia Ancestral",
    "desc": "Aumenta el ataque del héroe en 100%.",
    "rarity": 5,
    "baseCost": 260,
    "effect": { "kind": "stat", "stat": "atkPct", "add": 100 }
  },
  {
    "id": "card-critico-10",
    "name": "Ojo Certero",
    "desc": "Aumenta la probabilidad de golpe crítico en 10%.",
    "rarity": 2,
    "baseCost": 100,
    "effect": { "kind": "stat", "stat": "critPct", "add": 10 }
  },
  {
    "id": "card-vida-max-20",
    "name": "Corazón Robusto",
    "desc": "Aumenta la vida máxima del héroe en 20%.",
    "rarity": 1,
    "baseCost": 45,
    "effect": { "kind": "stat", "stat": "maxHpPct", "add": 20 }
  },
  {
    "id": "card-vida-max-50",
    "name": "Corazón de Roble",
    "desc": "Aumenta la vida máxima del héroe en 50%.",
    "rarity": 4,
    "baseCost": 200,
    "effect": { "kind": "stat", "stat": "maxHpPct", "add": 50 }
  },
  {
    "id": "card-armadura-4",
    "name": "Placa Reforzada",
    "desc": "Aumenta la armadura del héroe en 4 puntos.",
    "rarity": 1,
    "baseCost": 40,
    "effect": { "kind": "stat", "stat": "armor", "add": 4 }
  },
  {
    "id": "card-armadura-10",
    "name": "Coraza de Guardián",
    "desc": "Aumenta la armadura del héroe en 10 puntos.",
    "rarity": 4,
    "baseCost": 190,
    "effect": { "kind": "stat", "stat": "armor", "add": 10 }
  },
  {
    "id": "card-robo-vida-10",
    "name": "Sed de Batalla",
    "desc": "Otorga 10% de robo de vida con cada golpe.",
    "rarity": 3,
    "baseCost": 150,
    "effect": { "kind": "stat", "stat": "lifestealPct", "add": 10 }
  },
  {
    "id": "card-proyectil-extra-1",
    "name": "Carcaj Ampliado",
    "desc": "Añade 1 proyectil extra a cada disparo del héroe.",
    "rarity": 3,
    "baseCost": 150,
    "effect": { "kind": "stat", "stat": "bonusProjectiles", "add": 1 }
  },
  {
    "id": "card-proyectil-extra-3",
    "name": "Lluvia de Flechas",
    "desc": "Añade 3 proyectiles extra a cada disparo del héroe.",
    "rarity": 5,
    "baseCost": 250,
    "effect": { "kind": "stat", "stat": "bonusProjectiles", "add": 3 }
  },
  {
    "id": "card-bloqueo-30",
    "name": "Escudo Firme",
    "desc": "Aumenta la probabilidad de bloqueo en 30%.",
    "rarity": 2,
    "baseCost": 110,
    "effect": { "kind": "stat", "stat": "blockPct", "add": 30 }
  },
  {
    "id": "card-doble-ataque-60",
    "name": "Golpe Gemelo",
    "desc": "Aumenta la probabilidad de doble ataque en 60%.",
    "rarity": 5,
    "baseCost": 270,
    "effect": { "kind": "stat", "stat": "doubleAtkPct", "add": 60 }
  },
  {
    "id": "card-furia-oleada",
    "name": "Grito de Guerra",
    "desc": "Aumenta el ataque en 200%, solo durante la próxima oleada.",
    "rarity": 3,
    "baseCost": 130,
    "effect": { "kind": "stat", "stat": "nextWaveAtkPct", "add": 200 }
  },
  {
    "id": "card-fallo-enemigo-20",
    "name": "Niebla Confusa",
    "desc": "Aumenta en 20% la probabilidad de que los enemigos fallen sus golpes.",
    "rarity": 2,
    "baseCost": 95,
    "effect": { "kind": "stat", "stat": "enemyMissPct", "add": 20 }
  },
  {
    "id": "card-multiplicadores-random",
    "name": "Bendición del Tablero",
    "desc": "Convierte 3 barras del tablero, elegidas al azar, en multiplicadores ×1 extra.",
    "rarity": 3,
    "baseCost": 120,
    "effect": { "kind": "board", "mod": { "kind": "extraMultipliers", "count": 3, "value": 1 } }
  },
  {
    "id": "card-multiplicadores-random-plus",
    "name": "Milagro del Tablero",
    "desc": "Convierte 5 barras del tablero, elegidas al azar, en multiplicadores ×2 extra.",
    "rarity": 5,
    "baseCost": 240,
    "effect": { "kind": "board", "mod": { "kind": "extraMultipliers", "count": 5, "value": 2 } }
  },
  {
    "id": "card-trampolin-extra",
    "name": "Resorte Extra",
    "desc": "Añade un trampolín adicional al tablero de vertido.",
    "rarity": 2,
    "baseCost": 90,
    "effect": { "kind": "board", "mod": { "kind": "extraTrampoline" } }
  },
  {
    "id": "card-revela-misteriosas",
    "name": "Vista Clara",
    "desc": "Revela el valor de todas las barras misteriosas del tablero.",
    "rarity": 1,
    "baseCost": 55,
    "effect": { "kind": "board", "mod": { "kind": "revealMystery" } }
  },
  {
    "id": "card-curacion-20",
    "name": "Vendaje Rápido",
    "desc": "Cura al héroe un 20% de su vida máxima al instante.",
    "rarity": 2,
    "baseCost": 80,
    "effect": { "kind": "heal", "pct": 20 }
  },
  {
    "id": "card-curacion-50",
    "name": "Poción Mayor",
    "desc": "Cura al héroe un 50% de su vida máxima al instante.",
    "rarity": 4,
    "baseCost": 190,
    "effect": { "kind": "heal", "pct": 50 }
  }
]
